import script from "./ShareMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareMenu.vue?vue&type=script&setup=true&lang=js"

import "./ShareMenu.vue?vue&type=style&index=0&id=d2594fce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2594fce"]])

export default __exports__